import { wall } from './resource'

interface WallAvailability {
  available: boolean
}

/**
 * Checks to see if a wall's name can be set for the current user.
 * @param name The name of the wall. E.g. if the wall's address is https://padlet.com/syquek/mywall, the padlet's name (or `name`) is `mywall`.
 * @param wallId An optional parameter for if you're checking to see if name is valid for a particular wall with id `wallId`.
 * @returns A Promise that resolves to true if `name` is available for the current user, and for the wall with ID specified; false otherwise.
 */
export default async function checkWallAvailability (name: string, wallId?: number): Promise<boolean>  {
  let query: { [key: string]: string } = { name }
  if (wallId) query = { ...query, for_wall_id: wallId.toString() }
  const jsonResponse = await wall().get('check_availability', { query }) as WallAvailability
  return jsonResponse.available
}
